/**
 * The ONE empty value: "—", with WHY when the attribute serves a reason (owner rule: "—" with a reason).
 * The reason comes from the attribute's served display metadata (`display.empty_reason`, e.g. "Never signed
 * in"): visible on hover (title) and read out by screen readers (a visually hidden text). No reason served:
 * the widget's own empty rendering stands.
 */
export function EmptyValue({ reason }: { reason: string }) {
  return (
    <span className="text-muted-foreground" title={reason} data-testid="empty-value">
      <span aria-hidden="true">—</span>
      <span className="sr-only">{reason}</span>
    </span>
  )
}

/** The reason an attribute serves for an empty cell, or null. */
export function emptyReasonOf(attr: object | null | undefined): string | null {
  const reason = ((attr as { display?: unknown } | null | undefined)?.display as { empty_reason?: unknown } | null | undefined)?.empty_reason
  return typeof reason === 'string' && reason.trim() ? reason : null
}

/** Absent, blank or an empty list: what a cell has when it has no value. */
export function isEmptyCell(v: unknown): boolean {
  return v == null || (typeof v === 'string' && v.trim() === '') || (Array.isArray(v) && v.length === 0)
}
